function rebindBulkBuyEvents() {
  document.addEventListener('click', function (event) {
    // Check if the clicked element (or one of its ancestors) matches 'label.bulk-buy'
    const label = event.target.closest('label.bulk-buy');
    if (!label) return;
    const qty = label.getAttribute('data-qty');
    if (typeof window.updatePriceDisplay === 'function') {
      window.updatePriceDisplay(qty);
    } else {
      console.warn("updatePriceDisplay not defined when label clicked");
    }
    if (typeof window.updateMegaSalePrice === 'function') {
      window.updateMegaSalePrice(qty);
    }
  });
}

window.updatePriceDisplay = function(Value) {
    if (isNaN(Value) || Value <= 0) {
        console.warn('Invalid quantity:', Value);
        return;
    }

    // Remember the quantity the MAIN price is currently using, so the grab-at price can reuse the
    // exact same quantity (avoids picking up a stale/bulk-buy quantity input) on variant change / load.
    window.__wwMainQty = parseInt(Value, 10) || 1;

    const mainAddToBasketContainer = document.querySelector('.main-add-to-basket');
    const priceSections = document.querySelectorAll('.price_quantity_wrapper .price__container, product-info .price__container, .main-add-to-basket .price__container');

    const discountOne = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-one')) || 0 : 0;
    const discountTwo = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-two')) || 0 : 0;
    const discountThree = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-three')) || 0 : 0;

    const updateQuantityInputs = (Value) => {
        document.querySelectorAll('.price_quantity_wrapper .quantity__input').forEach(input => input.value = Value);
        document.querySelectorAll('.updated-product-quantity').forEach(input => input.setAttribute("value", Value));
        document.querySelectorAll('.price-per-item__container .quantity__button').forEach(button => {
           if (Value >= 2) {
            button.classList.remove('disabled');
          }
        });
    };

    // Percentage that applies to the selected pack size, 0 when none is configured.
    const getDiscountPct = (Value) => {
        if (Value > 2) return discountThree;
        if (Value > 1) return discountTwo;
        return discountOne;
    };

    // Takes the single-bottle price, not the line total: the discount comes off each bottle, see applyUnitCentDiscount
    const getDiscountedPrice = (unitPrice, Value) => {
        return applyUnitCentDiscount(unitPrice, Value, getDiscountPct(Value));
    };

    // Hoisted out of the price loop below: it used to run once per price container, so it
    // was skipped entirely whenever none matched and the cart got the stale quantity.
    updateQuantityInputs(Value);

    const checkedInput = document.querySelector('variant-selects input[type="radio"]:checked');
    const bulkBuy = document.querySelector('.main-bulk-buy');
    if (checkedInput && !bulkBuy) {
      let productWrapper = checkedInput.closest(".product__info-wrapper"); 
      let priceContainer = productWrapper.querySelector(".price__container");
      let selectedVariantPrice = parseFloat(checkedInput.getAttribute("product-option-variant-price")) / 100;
      let selectedVariantMrp = parseFloat(checkedInput.getAttribute("product-option-variant-mrp")) / 100;
      // alert(priceContainer.value);
      if (selectedVariantPrice && selectedVariantMrp > selectedVariantPrice) {
        priceContainer.innerHTML = ` <span class="price-item price-item--sale price-item--last">${formatPrice(selectedVariantPrice * Value)}</span>
        <s class="price-item price-item--compare price-item--regular">${formatPrice(selectedVariantMrp * Value)}</s>`
      } else {
        priceContainer.innerHTML = ` <span class="price-item price-item--sale price-item--last">${formatPrice(selectedVariantPrice * Value)}</span>`  
      }

      const totalRegularPrice = getProductPriceBasedOnQuantity(Value, selectedVariantPrice);
      updatePerServingPrice(priceContainer, totalRegularPrice, Value);
      // Update comfort points based on discounted or regular price
      updateCustomerPoints(Value, totalRegularPrice, totalRegularPrice);
    } else {

      priceSections.forEach(priceContainer => {
        const regularPrice = parseFloat(priceContainer.getAttribute('data-regular-price')) / 100;
        const compareAtPrice = parseFloat(priceContainer.getAttribute('data-compare-price')) / 100;
        const hasBulkDiscount = mainAddToBasketContainer && (
          mainAddToBasketContainer.hasAttribute('data-discount-one') ||
          mainAddToBasketContainer.hasAttribute('data-discount-two') ||
          mainAddToBasketContainer.hasAttribute('data-discount-three')
        );

        // Retrieve the stored flag from sessionStorage
        const xvdStored = sessionStorage.getItem('xvd_found');

        let isBulkApplicable;
        if (xvdStored === 'true') {
          // xvd was detected earlier in the session
          isBulkApplicable = false;
        } else {
          // Normal bulk logic. Qty 1 counts too, but only when a 1st-item discount is
          // configured — at 0% the single unit keeps its plain price / compare-at price.
          isBulkApplicable = hasBulkDiscount && getDiscountPct(Value) > 0;
        }

        const totalRegularPrice = getProductPriceBasedOnQuantity(Value, regularPrice);
        let totalCompareAtPrice;
        if (isBulkApplicable) {
            // When bulk discount is applied, compare-at = base price * qty
            totalCompareAtPrice = compareAtPrice ? getProductPriceBasedOnQuantity(Value, regularPrice) : null;
        } else {
            // Else, use actual compare-at * qty
            totalCompareAtPrice = compareAtPrice ? getProductPriceBasedOnQuantity(Value, compareAtPrice) : null;
        }

        let finalPrice = totalRegularPrice;
        if (isBulkApplicable) {
            finalPrice = getDiscountedPrice(regularPrice, Value);
        }

        priceContainer.innerHTML = '';

        if (Value == 1) {
          // Handle quantity = 1
          if (isBulkApplicable) {
            // A 1st-item discount is configured: strike the full unit price, same as the packs.
            priceContainer.innerHTML = `
              <span class="price-item price-item--sale price-item--last">${formatPrice(finalPrice)}</span>
              <s class="price-item price-item--compare price-item--regular">${formatPrice(regularPrice)}</s>
            `;
          } else if (compareAtPrice && compareAtPrice > regularPrice) {
            priceContainer.innerHTML = `
              <span class="price-item price-item--sale price-item--last">${formatPrice(regularPrice)}</span>
              <s class="price-item price-item--compare price-item--regular">${formatPrice(compareAtPrice)}</s>
            `;
          } else {
            priceContainer.innerHTML = `
              <div class="price__regular">
                <span class="price-item price-item--regular">${formatPrice(regularPrice)}</span>
              </div>
            `;
          }
        } else if (Value > 1 && totalCompareAtPrice) {
          // Show compare-at and regular for quantity > 1
          priceContainer.innerHTML = `
            <span class="price-item price-item--sale price-item--last">${formatPrice(finalPrice)}</span>
            <s class="price-item price-item--compare price-item--regular">${formatPrice(totalCompareAtPrice)}</s>
          `;
        } else if (finalPrice < totalRegularPrice) {
          // Discounted without compare-at
          priceContainer.innerHTML = `
            <span class="price-item price-item--sale price-item--last">${formatPrice(finalPrice)}</span>
            <s class="price-item price-item--regular">${formatPrice(totalRegularPrice)}</s>
          `;
        } else {
          // No discount or compare-at
          priceContainer.innerHTML = `
            <div class="price__regular">
              <span class="price-item price-item--regular">${formatPrice(totalRegularPrice)}</span>
            </div>
          `;
        }

        updatePerServingPrice(priceContainer, finalPrice, Value);

        // Update comfort points based on discounted or regular price
        updateCustomerPoints(Value, totalRegularPrice, finalPrice);
      });
    }
};

// Per-unit line under the main price (price-per-serving.liquid). It sits outside
// .price__container, which the block above rewrites wholesale, so it is re-worked here off the
// same final price. Scoped to the price block it belongs to, so the bulk tiles' own per-unit
// lines — fixed pack sizes, already correct — are left alone.
function updatePerServingPrice(priceContainer, finalPrice, quantity) {
    const line = priceContainer.closest('.price')?.parentElement?.querySelector(':scope > [data-price-per-serving]');
    if (!line) return;

    const servings = Number(line.getAttribute('data-servings')) || 0;
    const totalServings = servings * (Number(quantity) || 1);
    if (totalServings <= 0) return;

    // Truncated to the cent, the same integer divide price-per-serving.liquid does, so the line
    // never lands a cent away from the matching bulk tile.
    const perServing = Math.floor(Math.round(finalPrice * 100) / totalServings) / 100;
    const unit = line.getAttribute('data-serving-unit') || '';
    (line.querySelector('span') || line).textContent = `${formatPrice(perServing)} / ${unit}`;
}

function formatPrice(price) {
  let parts = price.toFixed(2).split('.');
  let integerPart = parts[0];
  let decimalPart = parts[1];

  // Add thousands separator (.) — Spanish format, comma for decimals
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return `${integerPart},${decimalPart}€`;
}

function getProductPriceBasedOnQuantity(Value, unitPrice) {
    return unitPrice * Value;
}

// Multipack price for `qty` bottles, rounded exactly like bulk-buy.liquid, which is what the cart charges: the
// discount comes off EACH bottle in whole cents rounded down, then that bottle price is multiplied by the quantity
// (2 x 14,49 € at 10% off is 26,10 €, not the 26,08 € a discount off the total gives). unitPrice and the return are
// euros; percent is a whole number such as 10. The small epsilon stops float noise (99.99999...) from flooring a
// whole cent away.
function applyUnitCentDiscount(unitPrice, qty, percent) {
    const unitCents = Math.round(unitPrice * 100);
    const discountCents = percent ? Math.floor((unitCents * percent) / 100 + 1e-6) : 0;
    return ((unitCents - discountCents) * qty) / 100;
}

function updateCustomerPoints(Value, totalRegularPrice, finalPrice) {
  const customerPointsElement = document.getElementById('comfortPoints');
  // Use the discounted price if there is a discount, else use the regular price
  let priceToUse = (finalPrice < totalRegularPrice) ? finalPrice : totalRegularPrice;
  let updatedPrice = priceToUse; // Convert from cents to euros
  const ceilCustomerPoints = Math.floor(updatedPrice);
  if (customerPointsElement) {
      customerPointsElement.innerText = `${ceilCustomerPoints}`;
  }
}

// Function to update comfort points based on bulk buy //
const customerPointsElement = document.getElementById('comfortPoints');
const bulkBuyInputs = document.querySelectorAll('.bulkbuy-input-element');
if(bulkBuyInputs){
  bulkBuyInputs.forEach(input => {
    input.addEventListener('change', function() {
      const points = this.getAttribute('data-points');
      if (customerPointsElement) {
        customerPointsElement.innerText = `${points}`;
      }
    });
  });
}
rebindBulkBuyEvents();


/***variant Updation code */
let lastUrl = location.href;
function highlightVariantImage() {
  const variantSelects = document.querySelector("variant-selects, .variant-selects");
  if (!variantSelects) return;

  const checkedInput = variantSelects.querySelector("input[type='radio']:checked");
  if (!checkedInput) return;

  const selectedValue = checkedInput.value.trim();
  if (!selectedValue) return;

  // Remove old highlights
  document.querySelectorAll(".variant-image-found").forEach(el =>
    el.classList.remove("variant-image-found")
  );

  // Highlight elements directly matching via data attributes
  const matchingElements = document.querySelectorAll("[data-variant-thumbnail-alt], [data-media-variant]");
  matchingElements.forEach(el => {
    const alt = el.getAttribute("data-variant-thumbnail-alt") || "";
    const media = el.getAttribute("data-media-variant") || "";
    if (alt.includes(selectedValue) || media.includes(selectedValue)) {
      el.classList.add("variant-image-found");
    }
  });

  // Highlight closest .owl-item for each .media_modal_wrapper
  document.querySelectorAll(".media_modal_wrapper").forEach(wrapper => {
    const variantAlt = wrapper.getAttribute("data-variant-thumbnail-alt") || "";
    const owlItem = wrapper.closest(".owl-item");

    if (!owlItem) return;

    if (variantAlt.includes(selectedValue)) {
      owlItem.classList.add("variant-image-found");
    } else {
      owlItem.classList.remove("variant-image-found");
    }
  });
}

// NOTE: Media (main slider + thumbnail slider + modal) is now rebuilt together
// from a single fetch inside product-info.js `updateMedia()` on variant change.
// This function used to do a SECOND fetch + wrapper replacement, which ran after
// the native update and caused the media to blink/rebuild twice. It is kept as a
// no-op so any remaining callers (e.g. the global.min.js change handler) do
// nothing instead of triggering that duplicate rebuild.
window.refreshScrollingAt = function () {
  /* intentionally left blank – see note above */
};


// Toggle visibility of bulk-buy options based on selected variant
function toggleBulkBuyVisibilityAndSelectFirst(e, targetID) {
  const el = e?.target || e;
  if (!el || !(el instanceof Element)) return;

  // Only respond to checked input
  if (el.tagName === 'INPUT' && !el.checked) return;

  const checkedInputvariantId = targetID;
  const wrapper = el.closest('.product__info-wrapper') || document;

  let firstVisibleBulkBuy = null;

  wrapper.querySelectorAll('.bulk-buy-inner').forEach(inner => {
    const bulkBuyVariantId = inner.getAttribute('data-variant-bulk-id')?.trim();

    if (checkedInputvariantId === bulkBuyVariantId) {
      inner.classList.remove("hidden");
      if (!firstVisibleBulkBuy) firstVisibleBulkBuy = inner;
    } else {
      inner.classList.add("hidden");
    }
  });

  // Select the first input inside the first visible bulk-buy-inner
  if (firstVisibleBulkBuy) {
    // Don't clobber an existing selection (e.g. restored from ?qty=); a newly
    // revealed block has nothing checked, so it still falls through to the first.
    const firstInput =
      firstVisibleBulkBuy.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked') ||
      firstVisibleBulkBuy.querySelector('input[type="radio"], input[type="checkbox"]');
    if (firstInput) {
      firstInput.checked = true;
      // Optionally, trigger change event if your logic depends on it
      firstInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  highlightVariantImage();
  //refreshScrollingAtc();
  rebindBulkBuyEvents();
}

// Auto-run on page load
// Trigger bulk-buy visibility if variant is pre-selected
const checkedInput = document.querySelector('variant-selects input[type="radio"]:checked');
if (checkedInput) {
  
  const variantId = checkedInput.getAttribute('product-option-variant-id');
  console.log("variantId",variantId);
  toggleBulkBuyVisibilityAndSelectFirst(checkedInput, variantId);
}

// Run other variant-related logic
if (
  location.href.includes('/products/') &&
  document.body.classList.contains('body-has-variants')
) {
  window.runVariantUpdateLogic?.();
}

setTimeout(() => {
  rebindBulkBuyEvents();
}, 300);

// On URL change, re-run variant logic
const observer = new MutationObserver(() => {
  const currentUrl = location.href;
  if (currentUrl !== lastUrl) {
    lastUrl = currentUrl;
    window.runVariantUpdateLogic?.();
  }
});
observer.observe(document.body, { childList: true, subtree: true });

// Product Reviews 
const reviewElement = document.querySelectorAll('#goAllReviews');

reviewElement?.forEach((each) => {
  each.addEventListener('click', (event) => {
    event.preventDefault();
    const reviewHref = each.getAttribute('href');
    const reviewWrapper = document.querySelector(reviewHref);  
    if (reviewWrapper) {
      smoothScrollToElement(reviewWrapper, 160)
    }
  });
})

function smoothScrollToElement(element, offset = 0) {
  const elementRect = element.getBoundingClientRect();
  const absoluteElementTop = elementRect.top + window.pageYOffset;
  const scrollPosition = absoluteElementTop - offset;
  
  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth'
  });
}

// Mega sale
document.querySelectorAll('.mega-sale-copy-button').forEach(function (button) {
  button.addEventListener('click', function () {
    const discountCode = this.dataset.discountCode;
    const tooltip = this.querySelector('.tooltiptext');

    if (!discountCode) return;

    // Copy to clipboard
    navigator.clipboard.writeText(discountCode).then(() => {
      // Show tooltip
      tooltip.classList.add('active');

      // Hide tooltip after 2 seconds
      setTimeout(() => {
        tooltip.classList.remove('active');
      }, 2000);
    });
  });

});
const knowMoreButton = document.querySelector('#mega_sale_know_more');
const megaSaleCloseButton = document.querySelector('.mega-sale-close-button')
const offerBoxContent = document.querySelector('#know_more_content');
const offerBox = document.querySelector('.offer-box__container');
knowMoreButton?.addEventListener('click', () => {
  if (offerBox) offerBox.classList.add('hidden');
  if (offerBoxContent) offerBoxContent.classList.remove('hidden');
})

megaSaleCloseButton?.addEventListener('click', () => {
  if (offerBox) offerBox.classList.remove('hidden');
  if (offerBoxContent) offerBoxContent.classList.add('hidden');
})

// Grab-at (mega sale) price — recomputed the same way comfort points are: read the CURRENTLY
// selected variant's price (from the checked variant radio, same source as the main price) and
// recompute, so it stays correct on quantity change, variant change, and page load. Percentage
// offers scale with the variant price (matching the Liquid: discount = floor(price * pct / 100));
// a fixed-amount offer keeps its per-unit price and only the savings move.
window.updateMegaSalePrice = function(qtyArg) {
  const megaSaleBox = document.querySelector('.mega-sale__offer_box');
  if (!megaSaleBox) return;

  // Quantity: use the value the caller passed (quantity/bulk handler), else the quantity the main
  // price last used (window.__wwMainQty, set by updatePriceDisplay), else 1. Never read a raw
  // quantity input here — there can be stale/bulk-buy inputs that don't match the displayed price.
  let qty = parseInt(qtyArg, 10);
  if (isNaN(qty) || qty <= 0) qty = parseInt(window.__wwMainQty, 10) || 1;

  // Current variant original price (cents) — from the checked variant radio (falls back to the box).
  const checkedInput = document.querySelector('variant-selects input[type="radio"]:checked');
  let originalPrice = checkedInput ? parseInt(checkedInput.getAttribute('product-option-variant-price'), 10) : NaN;
  if (isNaN(originalPrice)) originalPrice = parseInt(megaSaleBox.getAttribute('data-original-price'), 10) || 0;

  // Discounted per-unit price (cents): percentage offers scale with the variant; fixed offers stay.
  const pct = parseFloat(megaSaleBox.getAttribute('data-offer-percentage')) || 0;
  const discountedUnit = pct > 0
    ? originalPrice - Math.floor((originalPrice * pct) / 100)
    : parseInt(megaSaleBox.getAttribute('data-discounted-price'), 10) || 0;

  // Keep the box's data attributes in sync with the current variant.
  megaSaleBox.setAttribute('data-original-price', originalPrice);
  megaSaleBox.setAttribute('data-discounted-price', discountedUnit);

  const megaSalePriceElement = megaSaleBox.querySelectorAll('.mega-sale-price');
  const megaSaleSavePriceElement = megaSaleBox.querySelector('.mega-sale-extra-saving-price');

  const totalDiscounted = (discountedUnit * qty) / 100;
  const totalOriginal = (originalPrice * qty) / 100;

  megaSalePriceElement?.forEach((each) => each.textContent = formatPrice(totalDiscounted));
  if (megaSaleSavePriceElement) megaSaleSavePriceElement.textContent = formatPrice(totalOriginal - totalDiscounted);
};

// Variant change → recompute from the newly selected variant (read live). Changing the variant
// restarts the main price at quantity 1 (the quantity stepper resets), so the grab-at must reset
// to 1 too — otherwise it keeps the previous quantity and shows e.g. 12.00 × 2 = 24.00. Deferred a
// tick so the theme's own variant handlers settle first.
window.updateMegaSaleVariant = function() {
  window.__wwMainQty = 1;
  setTimeout(() => window.updateMegaSalePrice(1), 0);
};

// On load, sync the grab-at price to the initially selected variant (a non-default variant may be
// pre-selected client-side, while Liquid rendered the default). Runs after the theme's variant setup.
(function initMegaSaleOnLoad() {
  const run = () => setTimeout(() => window.updateMegaSalePrice(), 300);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

const circle = document.querySelector(".customer_service__text");
// Get current IST time
const now = new Date();
const istTime = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
const day = istTime.getDay();     // 0 = Sunday, 6 = Saturday
const hour = istTime.getHours();  // 0–23

// Check if it's Monday to Friday and between 12:00 noon and 11:59 PM IST
if (day >= 1 && day <= 5 && hour >= 12 && hour <= 23) {
  circle?.classList.remove('hidden');
} else {
  circle?.classList.add('hidden');
}

// custom BUY NOW JS
document.querySelectorAll('[id^="BuyNowButton-"]').forEach(button => {
  button.addEventListener("click", async function () {
    const productForm = button.closest('product-form');
    const form = productForm.querySelector('form');

    if (!form) return;

    button.setAttribute('disabled', true);

    const formData = new FormData(form);

    try {
      // Add product to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      // Get updated cart
      const cartResponse = await fetch('/cart.js');
      const cartState = await cartResponse.json();

      // Call your existing function
      if (typeof window.handleGiftProduct === 'function') {
        await window.handleGiftProduct(cartState);
      }

      // Redirect after gift logic completes
      window.location.href = '/checkout';

      setTimeout(() => {
        button.removeAttribute('disabled');
      }, 500);

    } catch (err) {
      console.error('Buy Now error:', err);
      button.removeAttribute('disabled');
    }
  });
});

// Multipack <-> ?qty= sync. The param is only written while the tiles are visible.
(function () {
  const QTY_PARAM = 'qty';
  const PACK_INPUT = 'input[name="bulk_buy_qty"]';

  // ":visible" test — catches display:none on the element or any ancestor.
  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  // Tiles of the shown variant block, or [] when the multipack isn't on screen.
  function getPackLabels() {
    if (location.pathname.indexOf('/products/') === -1) return [];

    const wrapper = document.querySelector('.main-bulk-buy');
    if (!isVisible(wrapper)) return [];

    const shownInner = Array.prototype.find.call(
      wrapper.querySelectorAll('.bulk-buy-inner'),
      (inner) => !inner.classList.contains('hidden')
    );
    if (!shownInner) return [];

    return Array.prototype.slice.call(shownInner.querySelectorAll('label.bulk-buy[data-qty]'));
  }

  function findLabel(labels, qty) {
    return Array.prototype.find.call(labels, (label) => label.getAttribute('data-qty') === String(qty));
  }

  function writeQtyToUrl(qty) {
    const url = new URL(window.location.href);
    if (url.searchParams.get(QTY_PARAM) === String(qty)) return;
    url.searchParams.set(QTY_PARAM, qty);
    // replaceState, not pushState: switching packs shouldn't stack up history entries.
    window.history.replaceState(window.history.state, '', url.toString());
  }

  function applyQtyFromUrl() {
    const labels = getPackLabels();
    if (!labels.length) return; // No multipack on screen -> leave the URL alone.

    const requested = new URLSearchParams(window.location.search).get(QTY_PARAM);
    // Matched against the tiles actually rendered — this store's are 1 / 2 / 3.
    // Anything else (4, 0, "abc", "03", missing) falls back to 1 pack.
    const target = findLabel(labels, requested) || findLabel(labels, 1) || labels[0];
    const qty = target.getAttribute('data-qty');

    const input = target.querySelector(PACK_INPUT);
    if (input && !input.checked) {
      target.click(); // real click, so every existing listener stays in the loop
    } else if (input && qty !== '1') {
      // bulk-buy-qty.js already ticked it; the rest of the page is still priced for 1 pack.
      input.dispatchEvent(new Event('change', { bubbles: true })); // loyalty points
      if (typeof window.updatePriceDisplay === 'function') window.updatePriceDisplay(qty);
    }

    writeQtyToUrl(qty);
  }

  // Every pack change — click or programmatic — mirrored back into the URL.
  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!input || typeof input.matches !== 'function' || !input.matches(PACK_INPUT) || !input.checked) return;

    const label = input.closest('label.bulk-buy[data-qty]');
    if (!label || !getPackLabels().length) return;

    writeQtyToUrl(label.getAttribute('data-qty'));
  });

  let applied = false;
  function runOnce() {
    if (applied) return;
    applied = true;
    applyQtyFromUrl();
  }

  // DOMContentLoaded so body.found_xvd_permeter is applied first; timeout is the fallback.
  document.addEventListener('DOMContentLoaded', runOnce);
  setTimeout(runOnce, 0);
})();

// Customer related Slider
const slider = document.querySelector(".customer-related-slider");

if (slider) {
  $(slider).owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 1300,

    // Blink / Fade Effect
    animateOut: "fadeOut",
    animateIn: "fadeIn",

    smartSpeed: 500,
    mouseDrag: false,
    touchDrag: false
  });
}
